/**
 * FINISH LAYOUT (2026-10-10, docs/bim-plan/34-finish-studio.md §1) — the kernel side: the
 * pattern vocabulary and the guard every reader uses. The pieces themselves are laid by
 * bim-geometry `finishLayout.ts`.
 */
import type { FinishLayoutPattern, FinishLayoutSpec } from './types'

export const FINISH_LAYOUT_PATTERNS: { id: FinishLayoutPattern; label: string }[] = [
  { id: 'stack', label: 'Stack (grid)' },
  { id: 'running', label: 'Running bond (1/2 offset)' },
  { id: 'third', label: 'Third offset (1/3)' },
  { id: 'random', label: 'Random-length planks' },
  { id: 'herringbone', label: 'Herringbone' },
  { id: 'basketweave', label: 'Basketweave' },
]

const PATTERNS = new Set<string>(FINISH_LAYOUT_PATTERNS.map((p) => p.id))

/** a layout that can actually be laid: a known pattern and real piece sizes (no runaway counts) */
export function validFinishLayout(v: FinishLayoutSpec | null | undefined): v is FinishLayoutSpec {
  if (!v || typeof v !== 'object' || !PATTERNS.has(v.pattern)) return false
  const w = Number(v.widthFt), l = Number(v.lengthFt), j = Number(v.jointFt)
  return w >= 0.5 / 12 && l >= w - 1e-9 && l <= 20 && Number.isFinite(j) && j >= 0 && j <= 2 / 12
}

/** the default grout (warm gray) */
export const DEFAULT_GROUT = '#bdb6aa'
